import { fetch } from '@utils/utils';
import * as T from '@modules/delicts/_delictsTypes';

export const getDelict = ({ addError }) => async (id: string): Promise<T.Delict> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/delicts/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    const json: T.Delict = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const putDelict = ({ addSuccess, addError }) => async (body: T.Delict): Promise<T.Delict | null> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/delicts/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    if (response.ok) {
      const json: T.Delict = await response.json();
      addSuccess('Přestupek byl úspěšně uložen');
      return json;
    } else {
      addError('Pri ukladaní došlo k chybe');
      return null;
    }
  } catch (err) {
    addError(err.message);
    return null;
  }
};

export const payDelict = ({ addSuccess, addError }) => async ({ id, isBNP, ...body }: any): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/ed/delicts/${id}/issue-${isBNP ? 'bnp' : 'bnz'}`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: body
    });

    if (response.ok) {
      addSuccess('Uloženo');
      return true;
    } else {
      addError('Pri ukladaní došlo k chybe');
      return false;
    }
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export const rebukeDelict = ({ addSuccess, addError }) => async ({ id, ...body }): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/ed/delicts/${id}/rebuke`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: body
    });

    if (response.ok) {
      addSuccess('Uloženo');
      return true;
    } else {
      addError('Pri ukladaní došlo k chybe');
      return false;
    }
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export const notHappenedDelict = ({ addSuccess, addError }) => async ({ id, ...body }): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/ed/delicts/${id}/issue-not-happened`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: body
    });

    if (response.ok) {
      addSuccess('Uloženo');
      return true;
    } else {
      addError('Pri ukladaní došlo k chybe');
      return false;
    }
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export const forwardedSoDelict = ({ addSuccess, addError }) => async ({ id, ...body }): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/ed/delicts/${id}/issue-forwarded-so`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: body
    });

    if (response.ok) {
      addSuccess('Uloženo');
      return true;
    } else {
      addError('Pri ukladaní došlo k chybe');
      return false;
    }
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export const saveSoDelict = ({ addSuccess, addError }) => async ({ delictId, body }): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/ed/isep/write-delict`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: { delictId },
      body: JSON.stringify(body)
    });

    if (response.ok) {
      addSuccess('Zapsáno v ISEP');
      return true;
    } else {
      addError('Zápis ISEP neproběhl');
      return false;
    }
  } catch (err) {
    addError(err.message || 'Zápis ISEP neproběhl');
    return false;
  }
};

export const undoFromDelict = ({ addSuccess, addError }) => async id => {
  try {
    const result = await fetch(`/metropolis/api/ed/delicts/${id}/undo`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    if (result.ok) {
      addSuccess('Řešení přestupku bylo zvráceno');
      return true;
    } else {
      addError('Při zvrácení řešení přestupku došlo k chybě');
      return false;
    }
  } catch (e) {
    addError(e.message);
    return false;
  }
};

export const deleteDelict = ({ addError, addSuccess }) => async (id: string): Promise<any> => {
  try {
    await fetch(`/metropolis/api/ed/delicts/${id}`, {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    addSuccess('Přestupek byl vymazán');
    return true;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const getDelictByOffender = ({ addError }) => async (formData: any): Promise<any> => {
  try {
    const response = await fetch(`/metropolis/api/ed/delicts/find-by-offender`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: formData
    });
    if (response.ok) {
      const json: T.Delict[] = await response.json();
      return json;
    } else {
      addError('Při ukládání došlo k chybe');
      return null;
    }
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const getDelictsByEvent = ({ addError }) => async (eventNumber: string) => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/delicts/parametrized`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        filter: [{ field: 'event.number', operation: 'EQ', value: eventNumber }]
      })
    });

    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      addError('Událost nenalezena');
      return null;
    }
  } catch (err) {
    addError(err.message);
    return null;
  }
};

export const syncPayment = ({ addSuccess, addError }) => async (fineId): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/tickets/register/${fineId}/register-ticket`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    if (response.ok) {
      addSuccess('Synchronizováno');
      return true;
    } else {
      addError('Při synchronizaci došlo k chybě');
      return false;
    }
  } catch (err) {
    addError(err.message);
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/modules/delicts/_delictsActions.ts